import Vue from 'vue'
import VueRouter from 'vue-router'

import { panelModule } from '@/static'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/dataPanel/whole'
  },
  {
    path: '/three',
    name: 'three',
    component: () => import('@/views/demo/three')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/dataPanel',
    name: 'dataPanel',
    component: () => import('@/views/panel'),
    children: [...panelModule.map(panel => {
      return {
        path: panel.name,
        name: panel.name,
        component: () => import(`@/views/${panel.name}`)
      }
    }), {
      path: 'transfer',
      name: 'transfer',
      component: () => import('@/views/panel/transfer')
    }]
  }
]

const router = new VueRouter({
  routes
})

export default router
